import enLabels from "./en-us.json";
const allMessages = {
    "en": {
        ...enLabels
    }
};

export const translate = (key, lang = "en") => {
    if (!key || typeof key !== "string") return '';
    const path = key.split('.');
    const translateKey = path[path.length - 1];
    let langCollection = allMessages[lang];
    if (!langCollection) {
        console.warn(`Language '${lang}' not found, falling back to 'en'`);
        langCollection = allMessages['en'];
    }
    if (path.length === 1) return langCollection[translateKey] || key;
    for (let i = 0; i < path.length - 1; i++) {
        langCollection = langCollection[path[i]];
        if (!langCollection){
            langCollection = allMessages[lang] || allMessages["en"];
            break;
        }
    }
    return langCollection[translateKey] || key;
};
